import { Blade, BladeLevel } from '@nrdy-marketing-engine/dropdown-menu';
import clsx from 'clsx';
import { useUserContext } from '../../server/src/user/context';

interface AccountNavItemProps {
  currentBlade: string;
  toggleBlade: (key, event) => void;
  className?: string;
  i18n: any;
}

export default function AccountNavItem({
  currentBlade,
  toggleBlade,
  className,
  i18n,
}: AccountNavItemProps) {
  const clientId = useUserContext();
  const signedInUser = !!clientId;

  if (!signedInUser) {
    return (
      <a
        className={clsx(
          'text-sm dark:text-base whitespace-nowrap hover:text-link dark:hover:text-white dark:hover:underline',
          className
        )}
        href={i18n.right.account.href}
      >
        {i18n.right.account.text}
      </a>
    );
  }

  const item = i18n.right.account_auth;
  const isOpen = currentBlade === item.text;

  return (
    <div className={clsx('relative', className)}>
      <button
        className={clsx(
          'text-sm dark:text-base whitespace-nowrap hover:text-link dark:hover:text-white dark:hover:underline',
          isOpen && 'text-link dark:text-white'
        )}
        onClick={toggleBlade.bind(this, item.text)}
      >
        <span className="block dropdown-arrow" dangerouslySetInnerHTML={{ __html: item.text }} />
      </button>
      <Blade className="flex right-0" rollup visible={isOpen}>
        <BladeLevel level={0}>{item.children}</BladeLevel>
      </Blade>
    </div>
  );
}
